import { Controller } from "@hotwired/stimulus"

// Mounts the embedded React editor (window.FasuaEditor) into this element on
// connect. Reads the initial authoring payload from a sibling JSON script tag,
// the CSRF token from the layout's meta tag, and the save URL from a data
// attribute on the controller element. Publishing is a CRUD action, not an
// editor concern.
//
// Usage:
//   <div data-controller="fasua-editor-mount"
//        data-fasua-editor-mount-state-id-value="fasua-editor-initial-state"
//        data-fasua-editor-mount-save-url-value="/admin/worksheets/1/payload">
//     <div data-fasua-editor-mount-target="root"></div>
//   </div>
export default class extends Controller {
  static targets = ["root"]
  static values = {
    stateId:    { type: String, default: "fasua-editor-initial-state" },
    mode:       { type: String, default: "edit" },
    saveUrl:    String
  }

  connect() {
    const root = this.hasRootTarget ? this.rootTarget : this.element
    const stateEl = document.getElementById(this.stateIdValue)
    const csrfEl = document.querySelector('meta[name="csrf-token"]')
    const initialWorksheet = stateEl ? JSON.parse(stateEl.textContent) : null
    const csrfToken = csrfEl ? csrfEl.getAttribute("content") : ""

    if (!window.FasuaEditor || typeof window.FasuaEditor.mount !== "function") {
      root.innerHTML = '<div style="padding:2rem;color:#b00020">FasuaEditor bundle failed to load.</div>'
      return
    }

    window.FasuaEditor.mount(root, {
      initialWorksheet,
      mode:       this.modeValue,
      saveUrl:    this.saveUrlValue,
      csrfToken
    })
  }
}
